import React from 'react';
import { Typography, Box } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Компонент для заголовков страниц
 * @param {Object} props - Свойства компонента
 * @param {string} props.title - Текст заголовка
 * @param {React.ReactNode} props.actions - Дополнительные элементы (кнопки, ссылки)
 */
const Title = ({ title, actions }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 3
      }}
    >
      <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 'bold', mb: 0 }}>
        {title}
      </Typography>
      {actions && (
        <Box sx={{ display: 'flex', gap: 1 }}>
          {actions}
        </Box>
      )}
    </Box>
  );
};

Title.propTypes = {
  title: PropTypes.string.isRequired,
  actions: PropTypes.node
};

export default Title; 